export default __webpack_public_path__ + "static/media/logo-white.1b8a617f.png";